module.exports = __webpack_public_path__ + "img/alpha-z-box.42e5d156.svg";